import config from "@/../config";
import active from "@/utils/axios/index";
import Vue from 'vue';
Vue.showGuidance = true
export function openApp(activeObj,globalStates,routerName) {
    let ua = navigator.userAgent.toLowerCase();
    Vue.$tea('event_new_share_landing_click', {
        locationId: activeObj.activityId,
        relationship: activeObj.relationship,
        landingPage:activeObj.landingPage || '',
        relationshipExtra2: activeObj.relationshipExtra2 || activeObj.activityId,
        parentUUID: activeObj.parentUUID || globalStates.shareParams.parentUUID,
        landingParam: activeObj.activityId,
        browserType: activeObj.browserType || judgingEnvironmen()
    });
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        Vue.$tea('event_new_share_landing_guide', {
            locationId: activeObj.locationId,
            relationship: activeObj.relationship,
            relationshipExtra2: activeObj.activityId,
            parentUUID: globalStates.shareParams.parentUUID,
            landingParam: activeObj.activityId,
            browserType: activeObj.browserType
        });
        // 判断是否在微信浏览器打开的
        // 传中转信息
        shareSetData(activeObj,globalStates,routerName);
    } else {
        // 尝试拉起233app，1.8秒后没拉起则下载app
        window.location.href = getScheme(activeObj,globalStates,routerName); //通过协议唤起233乐园
        let downloadApk = setTimeout((_) => {
            if(routerName === 'sakuraBox'){ // 樱花校园盒子下载地址使用这个
                window.location.href = "https://www.233leyuan.com/apiserv/api/deliveryTest/ABTest?id=zq_yhxymnq";
            }else{
                window.location.href = "http://cdn.233yang.cn/game/001/233leyuan.apk";
            }
            // 传中转信息
            shareSetData(activeObj,globalStates,routerName);
        }, 1800);
        window.addEventListener("visibilitychange", () => {
            const isHidden = document.hidden;
            if (isHidden) {
                clearTimeout(downloadApk);
            }
        });
    }
}

// 判断运行环境是 QQ-"1",微信-"2",其它-"0"
function judgingEnvironmen() {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") { // 在微信中打开
        return "2";
    } else if (ua.match(/QQ/i) == "qq") { // 在QQ中打开
        return "1";
    } else {
        return "0";
    }
}

function shareSetData(activeObj,globalStates,routerName = 'main') {
    const clickTime = Date.now();
    globalStates.shareParams.scheme = getScheme(activeObj,globalStates,routerName,clickTime);
    active.shareSetData(config.API_HOST + "/apiserv/api/share/dataRelay/setData", {
        ipUa: {
            key: "ipUa",
            funId: "5",
            info: globalStates.shareParams,
            clickTime: clickTime,
            validitySecond: 86400,
        },
    }).then((res) => {
        if (res.return_code != 200) {
            // this.$toast(res.return_msg);
            return;
        }
    }).catch((error) => {
        // this.$toast("网络不稳定，请稍后");
    });
}

function getScheme(activeObj,globalStates,routerName,time) {
    time = time || Date.now();
    let url;
    const env = window._API_HOST().NODE_ENV
    const shareBaseHost = window._API_HOST().shareBaseHost
    if (env === "production") {
        // 正式服
        url = "https://fw.233leyuan.com/active.modal/#/";
    } else if (env === "local") {
        // 本地
        url = "http://test-pod10-active-modal.233duan.cn/#/";
    } else {
        // 测试，预发
        url = shareBaseHost;
    }
    // f-分享功能ID,g-分享关系,c-分享关系参数,u-分享人的UUID
    const {
        locationId,
        relationship,
        relationshipParams,
        parentUUID,
        parentName,
        isHelp,
        teamCode
    } = globalStates.shareParams;
    const info = `{"locationId"=${locationId},"relationship"=${relationship},"relationshipParams"=${relationshipParams},"parentUUID"="${parentUUID}","parentName"="${parentName}","isHelp"=${isHelp}}`;
    let params;
    params = `funId=5&acquired=0&clickTime=${time}&info=${info}&url=${url}${routerName}?id=${activeObj.activityId}&f=${locationId}&g=${relationship}&c=${relationshipParams}&u=${parentUUID}&teamCode=${teamCode}`;
    return "metaapp://233xyx/web/web?" + params;
}

